import BaseService from './BaseService'
import axios from 'axios'

export default class SpaceshipService extends BaseService {
  static async getHangar () {
    const resp = await axios.get('/api/v1/protected/users/spaceships/hangar')

    return this.parseResponse(resp, false)
  }

  static async getSpaceship (id) {
    const resp = await axios.get(`/api/v1/protected/users/spaceships/${id}`)

    return this.parseResponse(resp, false)
  }
}
